// Remover protocolo de la url
export const urlWithoutProtocol = (drugManufacturerUrl: string) => {
    if(drugManufacturerUrl) {
        const withOutProtocol = drugManufacturerUrl.replace(/^(http?|https?|ftp):\/\//, '');
        const withOutWww = withOutProtocol.replace(/^(www\.)?/i, '')
        return withOutWww;
    }else {
        return '';
    };
};